import React, { useState, useEffect } from "react";
import { Button } from "./button";
import { Card, CardContent } from "./card";

import InputField from "./InputField";
import SelectField from "./SelectField";

const grupos = [
  "Biomédico",
  "Laboratorio",
  "Industrial",
  "Computo",
  "Impresión",
  "Digitalización",
];

const CatForm = ({ cat, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: "",
    grupo: "Biomédico",
  });

  useEffect(() => {
    if (cat) {
      setFormData({
        name: cat.name,
        grupo: cat.grupo,
      });
    }
  }, [cat]);

  // 🔑 handler único compatible con InputField y SelectField
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
      {/* Modal */}
      <div className="w-full max-w-2xl max-h-[90vh] bg-white rounded-2xl shadow-lg overflow-hidden flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h2 className="text-lg font-semibold text-gray-800">
            {cat ? "Editar categoría" : "Nueva categoría"}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-xl"
          >
            ✕
          </button>
        </div>

        {/* Scroll interno */}
        <div className="flex-1 overflow-y-auto">
          <Card className="border-none shadow-none">
            <CardContent className="p-6">
              <form onSubmit={handleSubmit} className="space-y-4">
                {/* Nombre */}
                <InputField
                  label="Nombre *"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Categoría"
                  required
                />

                {/* Grupo */}
                <SelectField
                  label="Tipo *"
                  name="grupo"
                  value={formData.grupo}
                  options={grupos.map((g) => ({
                    _id: g,
                    name: g,
                  }))}
                  onChange={handleChange}
                />

                {/* Footer */}
                <div className="flex justify-end gap-2 pt-4">
                  <Button variant="outline" onClick={onClose} type="button">
                    Cancelar
                  </Button>
                  <Button type="submit">{cat ? "Actualizar" : "Crear"}</Button>
                </div>
              </form>
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default CatForm;
